import(/* webpackMode: "eager" */ "/home/runner/work/bullseye/bullseye/apps/prospector/app/global-error.tsx");
